import { render, staticRenderFns } from "./OpeningTutorDetail.vue?vue&type=template&id=38f11606&scoped=true"
import script from "./OpeningTutorDetail.vue?vue&type=script&lang=js"
export * from "./OpeningTutorDetail.vue?vue&type=script&lang=js"
import style0 from "./OpeningTutorDetail.vue?vue&type=style&index=0&id=38f11606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f11606",
  null
  
)

export default component.exports